import { derived } from 'svelte/store';
import { locations, type Region } from '$lib/region';
import type { Language } from '$lib/lang';
import { getCurrentPath, getFullURL } from '$lib/utils/paths';
import { PUBLIC_APP_BASE_URL } from '$env/static/public';
import type { Readable } from '@square/svelte-store';
import { page } from '$app/stores';

export const locales: Readable<Array<{ href: string; hreflang: string }>> = derived(
  page,
  ($page) => {
    const appBaseUrl = PUBLIC_APP_BASE_URL || 'https://heyharper.com';

    const generatedLocales: Array<{ href: string; hreflang: string }> = [
      { href: appBaseUrl, hreflang: 'x-default' }
    ];

    Object.entries(locations).forEach(([key, value]) => {
      const { countryCode, languages } = value;

      languages.forEach((lang) => {
        const hreflang = `${lang.toLowerCase()}-${countryCode.toLowerCase()}`;

        const href = getFullURL({
          path: getCurrentPath($page.params) || '/',
          region: key as Region,
          lang: lang as Language,
          searchQuery: null
        });

        if (key === 'eu') {
          generatedLocales.push({
            href,
            hreflang: lang.toLowerCase()
          });
        } else {
          generatedLocales.push({
            href,
            hreflang
          });
        }
      });
    });

    return generatedLocales;
  }
);
